import { useMemo } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { entityTag } from './entityTags'
import { type CustomWorkflowLauncher, useCustomWorkflowLauncher } from './useCustomWorkflowLauncher'

export const useDocumentWorkflowLauncher = (documentId: string): CustomWorkflowLauncher => {
  const accountId = useAppSelector(selectAccountId)
  const context = useMemo(() => ({ document_id: documentId }), [documentId])

  return useCustomWorkflowLauncher({ accountId, scope: entityTag('document'), context })
}
